export const agreementsEndpoints = {
  listAgreements: { method: 'post', path: '/list' },
  uploadAgreements: { method: 'post', path: '/upload' },
  bulkUpdateAgreements: { method: 'post', path: '/bulk-update' },
  createAgreement: { method: 'post', path: '/create' },
  renameAgreement: { method: 'post', path: '/{agreementId}/rename' },
  getAgreementDetail: { method: 'get', path: '/{agreementId}' },
  getAgreementSubmission: { method: 'get', path: '/{agreementId}/submissions/{submissionType}/{submissionId}' },
  getDocumentsForAgreement: { method: 'get', path: '/{agreementId}/documents' },
  createAgreementTag: { method: 'post', path: '/{agreementId}/tags' },
  deleteAgreementTag: { method: 'post', path: '/{agreementId}/tags/delete' },
  agreementUpdateRenewal: { method: 'post', path: '/{agreementId}/renewal/update' },
  agreementCreateRenewal: { method: 'post', path: '/{agreementId}/renewal' },
  updateAgreement: { method: 'post', path: '/{agreementId}/update' },
  prefillEditAgreementForm: { method: 'get', path: '/{agreementId}/prefill-edit-form' },
  cancelAgreement: { method: 'post', path: '/{agreementId}/cancel' },
  deleteAgreement: { method: 'post', path: '/{agreementId}/delete' },
  listAgreementsMinimal: { method: 'post', path: '/list-minimal' },
  listAgreementsPaginated: { method: 'post', path: '/list-paginated' },
  generateAgreementName: { method: 'post', path: '/generate-name' },
  getAgreementHierarchy: { method: 'get', path: '/{agreementId}/hierarchy' },
  bulkSetParents: { method: 'post', path: '/bulk-set-parents' },
  setParent: { method: 'post', path: '/{agreementId}/set-parent' },
  setChild: { method: 'post', path: '/{agreementId}/set-child' },
  removeParentAgreement: { method: 'post', path: '/{agreementId}/remove-parent' },
} as const
